module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-portal-3.1bb57373.svg";